import axios from 'axios';

export const apiManager = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  withCredentials: true,
  // headers: {
  //   'X-Forwarded-Proto': process.env.REACT_APP_USE_HTTPS_FOR_ASSETS
  //     ? 'https'
  //     : 'http',
  // },
});

export default apiManager;
